var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 261,
    viewBox: "0 0 258 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -3,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 129 -3)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -2.29289,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 129 -2.29289)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.122 137.088C140.292 137.088 142.051 138.936 142.051 141.216V183.045C142.051 185.324 140.292 187.172 138.122 187.172C135.952 187.172 134.193 185.324 134.193 183.045V141.216C134.193 138.936 135.952 137.088 138.122 137.088Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.548 110.671C127.718 110.671 129.477 112.519 129.477 114.799V177.542C129.477 179.821 127.718 181.67 125.548 181.67C123.378 181.67 121.618 179.821 121.618 177.542V114.799C121.618 112.519 123.378 110.671 125.548 110.671Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.818 119.234C140.481 117.769 142.959 117.998 144.353 119.745L174.373 157.357C175.392 158.505 176.039 160.015 175.998 161.702C175.957 163.405 175.224 164.837 174.269 165.83C172.362 167.812 169.315 168.391 166.623 166.958C166.471 166.878 166.325 166.787 166.185 166.687L138.434 146.816L138.425 146.81C135.275 144.573 133.687 140.554 133.708 136.355C133.709 136.218 133.716 136.081 133.73 135.945L135.005 123.224C135.203 121.252 136.691 119.751 138.496 119.551C138.596 119.44 138.703 119.334 138.818 119.234ZM142.234 129.939L141.568 136.584C141.602 138.622 142.376 139.651 142.828 139.972L142.844 139.983L160.129 152.359L142.234 129.939Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.703 100.325C106.667 98.2703 111.182 99.3781 113.863 101.277C113.923 101.32 113.982 101.364 114.04 101.41L123.639 109.056C125.1 110.221 125.569 112.25 124.887 113.948C124.989 114.212 125.067 114.491 125.117 114.783C125.499 117.027 124.076 119.171 121.94 119.573L76.2178 128.159C72.5924 129.004 70.0069 126.368 69.2663 123.791C68.5036 121.137 69.3174 117.631 72.5085 115.977L102.703 100.325ZM114.953 112.498L109.4 108.075C109.036 107.836 108.46 107.597 107.805 107.512C107.119 107.424 106.564 107.53 106.18 107.729L86.7671 117.791L114.953 112.498Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.685 54.1701C156.186 54.791 158.597 57.2192 158.58 60.6712C158.58 60.7448 158.577 60.8185 158.573 60.892L156.594 96.2195C156.516 100.665 153.488 104.351 150.157 106.077C150.104 106.105 150.05 106.131 149.995 106.156L139.129 111.158C137.322 111.989 135.244 111.28 134.226 109.577C133.882 109.547 133.536 109.469 133.196 109.337C131.158 108.552 130.113 106.18 130.861 104.04L146.667 58.806C147.035 57.2936 147.853 55.8582 149.248 54.9253C150.716 53.9424 152.349 53.8385 153.685 54.1701ZM140.041 101.725L146.747 98.638C148.166 97.8723 148.734 96.6008 148.737 96.0499C148.737 95.9763 148.739 95.9027 148.744 95.8292L150.012 73.1911L140.041 101.725Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.931 110.671C131.471 110.671 129.477 112.765 129.477 115.349C129.477 117.933 131.471 120.027 133.931 120.027C136.39 120.027 138.384 117.933 138.384 115.349C138.384 112.765 136.39 110.671 133.931 110.671ZM121.618 115.349C121.618 108.206 127.131 102.415 133.931 102.415C140.73 102.415 146.243 108.206 146.243 115.349C146.243 122.492 140.73 128.283 133.931 128.283C127.131 128.283 121.618 122.492 121.618 115.349Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.612 168.186C113.685 168.186 121.806 170.167 130.346 176.166C151.302 190.806 168.749 176.552 168.958 176.386C170.635 174.955 173.097 175.231 174.459 177.047C175.822 178.808 175.56 181.45 173.831 182.826C173.621 182.991 151.617 200.988 125.997 183.046C105.041 168.351 87.5942 182.716 87.3847 182.826C85.7081 184.257 83.2457 183.982 81.8836 182.165C80.5214 180.404 80.7833 177.762 82.5123 176.386C82.6694 176.276 92.519 168.186 106.665 168.186H106.612Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 0.298998,
    y: 2.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarin);
export default __webpack_public_path__ + "static/media/marin.8289caedc50c582f02a9d5c177631f00.svg";
export { ForwardRef as ReactComponent };